import { render, staticRenderFns } from "./PolicyPopup.vue?vue&type=template&id=35c0cfd2&scoped=true"
import script from "./PolicyPopup.vue?vue&type=script&lang=js"
export * from "./PolicyPopup.vue?vue&type=script&lang=js"
import style0 from "./PolicyPopup.vue?vue&type=style&index=0&id=35c0cfd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c0cfd2",
  null
  
)

export default component.exports